import { string, object, array } from 'yup';
import { PriceSchema } from './CommonSchema';

export const HotelContentSchema = object().shape({
  gallery: object().required(),
  name: string(),
  address: object()
    .shape({
      line_1: string().required(),
      city: string().required(),
      country: string(),
      postal_code: string(),
    })
    .required(),
  rooms: array(),
});

export const RoomSchema = object().shape({
  gallery: object(),
  name: string().required(),
  rates: array().required(),
});

export const RateSchema = object().shape({
  price: object()
    .shape({
      average_nightly_price: object({
        display_price: PriceSchema.required(),
      }).required(),
      total_inclusive_price: PriceSchema.required(),
    })
    .required(),
  bed_groups: array().required(),
});
